<template>
  <div class="flex flex-wrap -mb-4" style="position: relative;">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 px-6 pt-6">
      <div class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['PositionAndDevice']['title']}}</span>
        <div v-show="stageIndex != 0 && _useStatus == true" class="float-right">
          <span class="text-sm mr-2">套用前階段設定</span>
          <InputSwitch v-model="stageContenttData.pdData.ditto_identity" class="-my-1" />
        </div>
      </div>
      <div class="flex-1 space-y-4">
        <div class="grid grid-cols-2 gap-8">
          <!-- 新手教學 -->
          <div class="space-y-2 pb-8 tiktok_cust">
            <div class="flex tiktok_cust">
              <input v-if="false" type="radio" class="form-radio h-5 w-5 text-blue-600" id="ingredient1" name="placement_type" v-model="stageContenttData.pdData.placement_type" value="PLACEMENT_TYPE_AUTOMATIC" :disabled="editPageType">
              <RadioButton class="form-radio h-5 w-5 text-blue-600" inputId="ingredient1" name="placement_type" v-model="stageContenttData.pdData.placement_type" value="PLACEMENT_TYPE_AUTOMATIC" :disabled="editPageType"/>
              <label for="ingredient1" class="ml-2">{{lang['components']['Event']['PositionAndDevice']['auto_position']}}</label>
            </div>
            <div class="flex tiktok_cust">
              <input v-if="false" type="radio" class="form-radio h-5 w-5 text-blue-600" id="ingredient2" name="placement_type" v-model="stageContenttData.pdData.placement_type" value="PLACEMENT_TYPE_NORMAL" :disabled="editPageType">
              <RadioButton class="form-radio h-5 w-5 text-blue-600" inputId="ingredient2" name="placement_type" v-model="stageContenttData.pdData.placement_type" value="PLACEMENT_TYPE_NORMAL" :disabled="editPageType"/>
              <label for="ingredient2" class="ml-2">{{lang['components']['Event']['PositionAndDevice']['edit_position']}}</label>
            </div>

            <!-- <div class="flex pt-8">
              <div>
                <span class="text-red-500">*</span>
                <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['position_block_title']}}</span>
              </div>
            </div> -->
            <!-- <MultiSelect v-model="stageContenttData.pdData.publisher_platforms" :options="stageContenttData.pdData.publisher_platforms_list" optionLabel="name" optionValue="code" placeholder="請選擇"
              :filter="false" class="w-2/5 multiselect-custom" display="chip" :disabled="stageContenttData.pdData.auto_publisher == true || editPageType">
            </MultiSelect> -->
            <!-- 新手教學 -->
            <MultiSelect ref="step47Click" id="teachingPAD" v-model="stageContenttData.pdData.placements" :options="publisherPlatformsList" optionDisabled="disabled" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']"
              :filter="false" class="w-full multiselect-custom rounded-md" :disabled="stageContenttData.pdData.placement_type == 'PLACEMENT_TYPE_AUTOMATIC' || editPageType">
              <template #value="slotProps">
                  <div class="country-item country-item-value" v-for="option of slotProps.value" :key="option.code">
                    <div>{{platFormLabel[option]}}</div>
                  </div>
                  <template v-if="!slotProps.value || slotProps.value.length === 0">
                      {{lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']}}
                  </template>
              </template>
            </MultiSelect>
          </div>
          <!-- 新手教學 -->
          <div class="space-y-2 py-8">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['device_block_title']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'關係鏈與受眾'"></i> -->
            </div>
            <Dropdown
              :disabled="editPageType" v-model="stageContenttData.pdData.operating_systems" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.user_os_list" :placeholder="lang['components']['Event']['PositionAndDevice']['device_block_title_placeholder']" class="w-full rounded-md"
            />
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-8">
        <div class="flex-1 space-y-4">
          <div class="space-y-2 pb-8" :class="{ 'cursor-not-allowed': editPageType === true }">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Identity']['identity_title']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'目標'"></i> -->
            </div>
            <input type="hidden" name="step_3_facebook" v-model="stageContenttData.pdData.identity_id">
            <Dropdown :disabled="editPageType" v-model="stageContenttData.pdData.identity_id" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.adpages_list" :placeholder="lang['components']['Event']['Identity']['identity_placeholder']" class="w-full rounded-md" />
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import RadioButton from 'primevue/radiobutton';
  import MultiSelect from 'primevue/multiselect';
  import Dropdown from 'primevue/dropdown';
  import InputSwitch from 'primevue/inputswitch';
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'

  export default {
    name: 'PositionAndDevice',
    components: {
      RadioButton,
      MultiSelect,
      Dropdown,
      InputSwitch
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      method: {
        type: String,
      },
      keywordViewDatalist: {
        type: Object
      },
      stageContent:{
        type: Object
      },
      stageContentAll:{
        type: Object
      },
      stageIndex: {
        type: Number
      },
      autoPublisher: {
        type: Boolean
      },
      publisherPlatforms: {
        type: Object
      },
      lang: {
        type: Object
      },
      keywordsSelectedList: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        autoPublisherForm: false,
        testValue: ["mobile","desktop"],
        devicePlatformsList: [
          {
            name: "行動裝置",
            code: "mobile",
            disabled: false
          },
          {
            name: "桌上型電腦",
            code: "desktop",
            disabled: false
          }
        ],
        selectDeviceLabel: {mobile:"行動裝置", desktop:"桌上型電腦"},
        publisherPlatFormsDb: [],
        platFormLabel: {PLACEMENT_TIKTOK:"TikTok", PLACEMENT_GLOBAL_APP_BUNDLE:"Global App Bundle", PLACEMENT_PANGLE:"Pangle"},
        usAuto: true,
        selectedTags: [3, 7],
        tags: [
          {
            code: 1,
            text: '排除粉絲專頁',
            checked: false
          },
          {
            code: 2,
            text: '排除購買15天',
            checked: false
          },
          {
            code: 3,
            text: '排除購買30天',
            checked: true
          },
          {
            code: 4,
            text: '排除購買60天',
            checked: false
          },
          {
            code: 5,
            text: '排除RT30天',
            checked: true
          },
          {
            code: 6,
            text: '排除RT60天',
            checked: false
          },
          {
            code: 7,
            text: '預設選項',
            checked: false
          },
        ],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        ingredient: 'PLACEMENT_TYPE_AUTOMATIC',
        publisherPlatformsList: [
          {name: 'Facebook', code: 'facebook', disabled: false},
          {name: 'Instagram', code: 'instagram', disabled: false},
          {name: 'Audience Network', code: 'audience_network', disabled: false},
          {name: 'Messenger', code: 'messenger', disabled: false}
        ],
        _useStatus: false
      }
    },
    watch: {
      // 'stageContenttData.pdData.publisher_platforms'(value){
      //   console.log('stageContenttData.pdData.publisher_platforms');
      //   console.log(value);
      //   let platformsLength = value.length;
      //   console.log(platformsLength);
      //   console.log(this.stageContenttData.pdData.publisher_platforms);
      //   this.stageContenttData.pdData.placements = value
      //   if(platformsLength == 4){
      //     this.autoPublisherForm = true;
      //     this.autoPublisherData = true;
      //   } else {
      //     this.autoPublisherForm = false;
      //     this.autoPublisherData = false;
      //   }
      // },
      // 'autoPublisherData'(value){
      //   console.log('autoPublisherData');
      //   console.log(value);
      //   console.log(typeof value);
      //   if(value){
      //     this.autoPublisherForm = true;
      //     this.stageContenttData.pdData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
      //     this.stageContenttData.pdData.placements = ["facebook","instagram","audience_network","messenger"];
      //   } else {
      //     this.autoPublisherForm = true;
      //     this.stageContenttData.pdData.publisher_platforms = [];
      //     this.stageContenttData.pdData.placements = [];
      //   }
      // },
      'stageContenttData': function(v){
        console.log('CustomizeTiktokEvent PositionAndDevice stageContenttData');
        console.log(v);
        console.log(this.stageIndex);
        console.log(this.stageContentAllData);

        let _beforeIndex = this.stageIndex - 1;
        let _tmpThisMethod = this.stageContentAllData.subCampaignsContent[this.stageIndex].method;
        let _tmpBeforeMethod = '';
        let metaList = ['META_TEST','META_KW','META_LA','META_RT','META_ASC'];
        let tiktokList = ['TIKTOK_KW','TIKTOK_RT'];

        console.log('_beforeIndex');
        console.log(_beforeIndex);
        if(_beforeIndex >= 0){
          _tmpBeforeMethod = this.stageContentAllData.subCampaignsContent[_beforeIndex].method;
        }

        console.log(_tmpThisMethod+' vs '+_tmpBeforeMethod);

        let _thisIsMeta = false;
        let _beforeIsMeta = false;
        let _thisIsTiktok = false;
        let _beforeIsTiktok = false;
        let _allIsMeta = false;
        let _allIsTiktok = false;

        if (metaList.includes(_tmpThisMethod)) {
          _thisIsMeta = true
        }

        if (metaList.includes(_tmpBeforeMethod)) {
          _beforeIsMeta = true
        }

        if (tiktokList.includes(_tmpThisMethod)) {
          _thisIsTiktok = true
        }

        if (tiktokList.includes(_tmpBeforeMethod)) {
          _beforeIsTiktok = true
        }

        if(_thisIsMeta == true && _beforeIsMeta == true){
          _allIsMeta = true;
        }

        if(_thisIsTiktok == true && _beforeIsTiktok == true){
          _allIsTiktok = true;
        }

        if(_allIsMeta == true || _allIsTiktok == true){
          this._useStatus = true;
        } else {
          this._useStatus = false;
        }

        console.log('_thisIsMeta');
        console.log(_thisIsMeta);
        console.log('_beforeIsMeta');
        console.log(_beforeIsMeta);
        console.log('_thisIsTiktok');
        console.log(_thisIsTiktok);
        console.log('_beforeIsTiktok');
        console.log(_beforeIsTiktok);
        console.log('_allIsMeta');
        console.log(_allIsMeta);
        console.log('_allIsTiktok');
        console.log(_allIsTiktok);
        console.log('this._useStatus');
        console.log(this._useStatus);
      },
      'stageContenttData.pdData.publisher_platforms_list': function(v){
        console.log('stageContenttData.pdData.publisher_platforms_list');
        console.log(v);
      },
      'method': function(v){
        console.log('method');
        console.log(v);
        if(v == 'TIKTOK_KW' || v == 'TIKTOK_RT'){
          this.publisherPlatformsList = [
            {name: 'TikTok', code: 'PLACEMENT_TIKTOK'},
            {name: 'Global App Bundle', code: 'PLACEMENT_GLOBAL_APP_BUNDLE'},
            {name: 'Pangle', code: 'PLACEMENT_PANGLE'}
          ];
        } else {
          this.publisherPlatformsList = [
            {name: 'Facebook', code: 'facebook', disabled: false},
            {name: 'Instagram', code: 'instagram', disabled: false},
            {name: 'Audience Network', code: 'audience_network', disabled: false},
            {name: 'Messenger', code: 'messenger', disabled: false}
          ];
        }
        console.log(this.publisherPlatformsList);
      },
      'lang':function(v){
        this.devicePlatformsList = [
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_mobile'],
            code: "mobile",
            disabled: false
          },
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_desktop'],
            code: "desktop",
            disabled: false
          }
        ];
        this.selectDeviceLabel = {mobile:this.lang['components']['Event']['PositionAndDevice']['device_mobile'], desktop:this.lang['components']['Event']['PositionAndDevice']['device_desktop']};
      },
      'stageContenttData.pdData.device_platforms':function(v){
        console.log('stageContenttData.pdData.device_platforms');
        console.log(v);

        // let devicePlatformsLength = v.length;

        // if(v[0] == "desktop" && devicePlatformsLength == 1){
        //   this.stageContenttData.pdData.publisher_platforms_list = [
        //     {name: "Facebook", code: "facebook", disabled: true},
        //     {name: "Instagram", code: "instagram", disabled: true},
        //     {name: "Audience Network", code: "audience_network", disabled: true},
        //     {name: "Messenger", code: "messenger", disabled: true},
        //   ];
        //   this.stageContenttData.pdData.placements = ["facebook"];
        // } else {
        //   this.stageContenttData.pdData.publisher_platforms_list = [
        //     {name: "Facebook", code: "facebook", disabled: false},
        //     {name: "Instagram", code: "instagram", disabled: false},
        //     {name: "Audience Network", code: "audience_network", disabled: false},
        //     {name: "Messenger", code: "messenger", disabled: false},
        //   ];
        // }

        // if(devicePlatformsLength == 2){
        //   this.autoPublisherForm = true
        // } else {
        //   this.autoPublisherForm = false
        // }
      },
      'stageContenttData.pdData.operating_systems': function(v){
        console.log('stageContenttData.pdData.operating_systems');
        console.log(v);
      },
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'pad'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      guideStep(val) {
        // this.$refs.step47Click.show();
        // this.$refs.step47Click.overlayVisible = value === 47 ? true : false;
        if (val == 47) {
          // console.log(value);
          // this.$refs.step47Click.overlayVisible = true;
          // console.log(this.$refs.step47Click);
          // console.log(this.$refs.step47Click.overlayVisible);

          // this.$refs.step47Click.show();
          // document.getElementById("test").click();

          setTimeout(function(){
              // console.log("I am the third log after 1 seconds");
              document.getElementById("teachingPAD").click();
          },350);
        }
      },
      // 'publisherPlatformsData'(value){
      //   console.log('publisherPlatformsData');
      //   console.log(value);

      //   this.stageContenttData.pdData.placements = value;

      //   console.log('this.stageContenttData.pdData.placements');
      //   console.log(this.stageContenttData.pdData.placements);
      // },
      // 'autoPublisherForm'(value){
      //   console.log('autoPublisherForm');
      //   console.log(value);

      //   this.stageContenttData.pdData.auto_publisher = value;
      // },
      'stageContenttData.pdData.placements'(value){
        console.log('stageContenttData.pdData.placements');
        console.log(value);

        if(value != '' && value != null && typeof value != 'undefined'){
          let _length = value.length;
          let _tiktok = 1;
          console.log(_tiktok);

          for (let i = 0; i < _length; i++) {
            if(value.includes('PLACEMENT_TIKTOK') == false){
              console.log('沒勾 tiktok');
              _tiktok = 0;
              break;
            }
          }

          console.log('this.keywordsSelectedList');
          console.log(this.keywordsSelectedList);

          console.log(_tiktok);
          console.log('b this.keywordViewDatalist');
          console.log(this.keywordViewDatalist);

          let tiktok_status = 'false_0';

          if(_tiktok == 0){
            let _tmp_selectedCategories = {};

            Object.keys(this.keywordsSelectedList).forEach(key => {
              let _key_data = key.split('|');
              if(_key_data[1] == 'interest_categories'){
                _tmp_selectedCategories[key] = {checked: this.keywordsSelectedList[key].checked, partialChecked: this.keywordsSelectedList[key].partialChecked};
              }
            });

            console.log('_tmp_selectedCategories');
            console.log(_tmp_selectedCategories);

            this.keywordViewDatalist.creator_action_categories = [];
            this.keywordViewDatalist.interest_keywords = [];
            this.keywordViewDatalist.video_action_categories = [];
            this.keywordViewDatalist.hashtags = [];

            this.$emit('childReturnKeywords', _tmp_selectedCategories);

            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            todayForm = yearForm + monthForm + dateForm + timeForm;

            tiktok_status = 'true_'+todayForm;
          }

          this.$emit('childNoTiktok', tiktok_status);

          console.log('a this.keywordViewDatalist');
          console.log(this.keywordViewDatalist);
        }
      },
      'stageContenttData.pdData.identity_id': function(v){
        console.log('watch stageContenttData.pdData.identity_id');
        console.log(v);

        this.$emit('childPageId', v);

        // if(v != '' && v != null){
        //   this.showIdentityMyside = false;

        //   axios
        //     .post('https://test.autoturn.net/inside/api/campaign_page_instagram.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       identity_id: v,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){
        //         console.log('response:'+response.data.return_data);
        //         // console.log('b this.stageContenttData.pdData.ig_username:'+this.stageContenttData.pdData.ig_username);
        //         this.stageContenttData.pdData.ig_username = response.data.return_data;
        //         this.stageContenttData.pdData.ig_id = response.data.ig_id;
        //         this.stageContenttData.pdData.ig_list = response.data.data_list;
        //         // console.log('a this.stageContenttData.pdData.ig_username:'+this.stageContenttData.pdData.ig_username);
        //       }

        //       this.showIdentityMyside = true;
        //     });
        // }
      }
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingMethod');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_pad')

        this.vars.start = 0
        this.vars.end = 16
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      testPAD() {
        console.log('hello')
        this.$refs.step47Click.show();
        this.$refs.step47Click.overlayVisible = true;
        console.log(this.$refs.step47Click);
      },
      selectAll (event) {
        // console.log(this.autoPublisherData)
        if(this.editPageType == false){
          if(!this.autoPublisherForm){
            this.autoPublisherForm = true;
            this.autoPublisherData = true;
            // this.stageContenttData.pdData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
            // this.stageContenttData.pdData.placements = ["facebook","instagram","audience_network","messenger"];
            // this.stageContenttData.pdData.device_platforms = ["mobile","desktop"];
          } else {
            this.autoPublisherForm = false;
            this.autoPublisherData = false;
            // this.stageContenttData.pdData.publisher_platforms = ["facebook"];
            // this.stageContenttData.pdData.placements = ["facebook"];
            // this.stageContenttData.pdData.device_platforms = ["desktop"];
          }
        }

        // if (!this.isSelect) {
        //   console.log('is checked');
        //   this.list.map(function(value, key) {
        //     console.log('value:'+value.name)
        //     if(value.status == 1){
        //       value.status = 2;
        //     }
        //   });
        // } else {
        //   console.log('un checked');
        // }
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      stageContenttData:{
        get: function () {
          return this.stageContent
        },
        set: function (value) {
          this.$emit('update:stageContenttData', value)
        },
      },
      stageContentAllData:{
        get: function () {
          return this.stageContentAll
        },
        set: function (value) {
          this.$emit('update:stageContentAllData', value)
        },
      },
      autoPublisherData: {
        get: function () {
          return this.autoPublisher
        },
        set: function (value) {
          this.$emit('update:autoPublisherData', value)
        },
      },
      publisherPlatformsData: {
        get: function () {
          return this.publisherPlatforms
        },
        set: function (value) {
          this.$emit('update:publisherPlatformsData', value)
        },
      },
    },
  }
</script>
<style lang="scss" scoped>
  /*::v-deep(.multiselect-custom) {
    .p-multiselect-token {
      font-size: .875rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.25rem;
      display: inline-flex;
      margin: 0.25rem;
      --tw-bg-opacity: 1;
      background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgba(255, 255, 255, var(--tw-text-opacity));
    }
  }*/

  ::v-deep(.multiselect-custom) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }

    .country-item-value {
        padding: .25rem .5rem;
        border-radius: 3px;
        display: inline-flex;
        margin-right: .5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);

        img.flag {
            width: 17px;
        }
    }
  }
</style>
<style type="text/css">
  .tiktok_cust .multiselect-custom .p-multiselect-label-container .p-multiselect-label .country-item-value {
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: #111827;
    color: #fff;
  }
</style>